// import Frame from "./frame";

export default class TooltipHandler {
	constructor() { }

	static init() {

		// Tooltip
		this.initTooltips();

		$(document).on("click", '[data-toggle="collapse"]', function (e) {
			e.preventDefault();
			$($(this).attr('href')).toggle();
		});

		// Fake select and tooltip
		$("[data-toggle-target]").each(function (i, link) {
			var link = $(link);

			//add class
			link.addClass("fake-select");

			//add tooltip
			link.attr("data-original-title", Frame.msg.open);
			link.tooltip();
		})

		// Toggle link
		$(document).on("click", "[data-toggle-target]", function (e) {
			e.preventDefault();

			var link = $(this);
			var target_objs = $(link.data("toggle-target") + ":not(.collapse)");

			if (target_objs.first().is(":visible")) {
				link.removeClass("open");
				target_objs.slideUp();

				link.attr("data-original-title", Frame.msg.open);
			}
			else {
				link.addClass("open");
				target_objs.fadeIn();

				link.attr("data-original-title", Frame.msg.close);
			}

			if (link.data("remove-after-click")) {
				let block = link.closest(".form-section").length ? link.closest(".form-section") : link;
				block.remove();
			}

			link.tooltip("hide");
		});
	}

	static initTooltips() {
		$('[data-toggle="tooltip"], [data-bs-toggle="tooltip"]').tooltip();
	}
}